import styled from 'styled-components'

export const ButtonContainer = styled.div`
  width: 92%;
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
`
